module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAbFBMVEUAAAA+ftM+f9Q9f9M+gNM8fdI5ftE+gNM8fdI+ftM9f9M9ftM8fdM9f9M+f9Q+f9Q8gNI9f9M+f9I8f9M9f9M9f9M9ftI8ftQ6ftIzd8w+ftM+f9I+f9I9f9M9ftQ/gNM9gNI9fNE+fNM+f9NpiGB4AAAAI3RSTlMAf/fQWh8WszPvu0s6qaFSRPuZg9aeY00nD+jfx79xbmxUKS/62I0AAACjSURBVCjPrZDrCsMgDEar2WZ1au113f2S93/HZRYGBmET+v04kRwk0eqTpsUkl+obgWlkoiQA6IVc3anMOBEtVxsqO9wTtwVqis0n8cXVyTkHePbeA1dDL4RCIJr8rIY4r7OhiI99EANXKKUkaq1brlxd1zcciSI/6/BjjYJbKoQg0Ftre6aSFCnTdd2YVfFvj38rpYbYAGPMNZ5apRaFuVD/DYmZIi8zO3USAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/login2icon.png
// module id = D0B1
// module chunks = 1